module.exports = __webpack_public_path__ + "img/Union2.277db68b.svg";